export class AlertDialogModel {
    Id: number;
    HeadingText: string;
    BodyText: string;
    BodyInput: string;
    ActionButtonText: string;
    AlertMsg: string;
    IsAction: boolean;
    cancelButtonText:string;

    constructor() {
        this.Id = 0;
        this.HeadingText = '';
        this.BodyText = '';
        this.BodyInput = '';
        this.ActionButtonText = '';
        this.AlertMsg = '';
        this.IsAction = false;
        this.cancelButtonText = '';
    }
}
